module.exports = __webpack_public_path__ + "static/coffee-bean-plant-08fff69b377c6ed9d14a650bb8027a51.png";